// https://github.com/microsoft/TypeScript/issues/13965
export class HTTPError extends Error {
  statusCode = 500;
  constructor() {
    super();
    this.name = "HTTPError";
    this.message = "";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

// Technical Errors

export class ValidationError extends HTTPError {
  readonly statusCode = 400;
  constructor(message?: string) {
    super();
    this.name = "ValidationError";
    this.message = message || "Missing or invalid value(s) provided.";
  }
}

export class UnauthorizedError extends HTTPError {
  readonly statusCode = 401;
  constructor(message?: string) {
    super();
    this.name = "UnauthorizedError";
    this.message = message || "Missing authentication.";
  }
}

export class ItemNotFoundError extends HTTPError {
  readonly statusCode = 404;
  constructor(message?: string) {
    super();
    this.name = "ItemNotFoundError";
    this.message = message || "Requested DGA could not be found.";
  }
}

// Business Errors

export class MarketNotSupportedError extends HTTPError {
  readonly statusCode = 501;
  constructor(message?: string) {
    super();
    this.name = "MarketNotSupportedError";
    this.message = message || "The market is not supported.";
  }
}

export class LocaleNotSupportedError extends HTTPError {
  readonly statusCode = 501;
  constructor(message?: string) {
    super();
    this.name = "LocaleNotSupportedError";
    this.message = message || "The locale is not supported.";
  }
}

export class EECNotAvailableError extends HTTPError {
  readonly statusCode = 500;
  constructor(message?: string) {
    super();
    this.name = "EECNotAvailableError";
    this.message =
      message ||
      "Energy Efficiency Category (EEC) value could not be retrieved.";
  }
}

export class WltpDataNotAvailableYetError extends HTTPError {
  readonly statusCode = 500;
  constructor(message?: string) {
    super();
    this.name = "WltpDataNotAvailableYetError";
    this.message = message || "WLTP data could not be retrieved.";
  }
}

export class VinClientError extends HTTPError {
  readonly statusCode = 400;
  constructor(message?: string) {
    super();
    this.name = "VinClientError";
    this.message =
      message || "Could not retrieve valid data for requested VIN.";
  }
}

export class VinServerError extends HTTPError {
  readonly statusCode = 502;
  constructor(message?: string) {
    super();
    this.name = "VinServerError";
    this.message = message || "Failed to retrieve data from external service.";
  }
}

export class MarketingCodeClientError extends HTTPError {
  readonly statusCode = 400;
  constructor(message?: string) {
    super();
    this.name = "MarketingCodeClientError";
    this.message =
      message || "Could not retrieve valid data for requested marketing code.";
  }
}

export class MarketingCodeServerError extends HTTPError {
  readonly statusCode = 502;
  constructor(message?: string) {
    super();
    this.name = "MarketingCodeServerError";
    this.message = message || "Failed to retrieve data from external service.";
  }
}

export class AudiCodeClientError extends HTTPError {
  readonly statusCode = 400;
  constructor(message?: string) {
    super();
    this.name = "AudiCodeClientError";
    this.message =
      message || "Could not retrieve valid data for requested marketing code.";
  }
}

export class AudiCodeServerError extends HTTPError {
  readonly statusCode = 502;
  constructor(message?: string) {
    super();
    this.name = "AudiCodeServerError";
    this.message = message || "Failed to retrieve data from external service.";
  }
}

export class ModelTooOldError extends HTTPError {
  readonly statusCode = 451;
  constructor(message?: string) {
    super();
    this.name = "ModelTooOldError";
    this.message = message || "Requested model is too old to be visualized.";
  }
}
